import red from "@material-ui/core/colors/red";
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submitButton: {
    margin: theme.spacing(0, 0, 2),
    height: 35,
  },
  errorMessage: {
    color: red[500],
  },
  formWrapper: {
    width: "100%",
    maxWidth: 480,
    padding: "0 40px",
  },
  loginContent: {
    width: "100%",
    backgroundColor: "#4187B6",
    minHeight: "100VH",
  },
  wrapperLogin: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  logo: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 40,
    width: "100%",
    maxWidth: 276,
  },
  loginLeftContent: {
    backgroundColor: "#FFFFFF",
    minHeight: "100VH",
    height: "100%",
    width: "50%",
    marginTop: 0,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 0",
      width: "100%",
    },
  },
  testimonialsContainer: {
    [theme.breakpoints.up("md")]: {
      marginTop: -100,
    },
  },
  loginRightContent: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 0",
      minHeight: "100VH",
      width: "100%",
    },
  },
  forgotLink: {
    textAlign: "left",
  },
  resendWelcomeEmailLink: {
    textAlign: "right",
  },
  welcomeTitle: {
    fontSize: 35,
    lineHeight: 1.31,
    color: "#FFFFFF",
    position: "relative",
    fontFamily: "'Roboto Slab', serif",
    textAlign: "center",
  },
  welcomeSeparator: {
    marginTop: 5,
    backgroundColor: "#FFFFFF",
    height: 3,
    width: 100,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
  supportContainer: {
    marginTop: theme.spacing(2),
  },
  actionsFooter: {
    height: "56px",
    background: "#f1f1f1",
    paddingLeft: "5px",
    paddingRight: "5px",
    marginTop: "20px",
  },
  supportInfoLabel: {
    fontStyle: "italic",
    color: theme.palette.text.secondary,
  },
  supportHighlightText: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
}));
